import {NgModule} from '@angular/core';
import {Routes, RouterModule, PreloadAllModules} from '@angular/router';
import {LayoutComponent} from './layout/layout.component';
import {MaintenanceComponent} from './shared/components/maintenance/maintenance.component';
import {LoginCComponent} from './modules/login-mod/login-c/login-c.component';
import {LoggedGuard} from '@core/guard/logged.guard';

const routes: Routes = [
  {
    path: 'system',
    component: LayoutComponent,
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./modules/home/home.module').then(m => m.HomeModule),
      },
      {
        path: 'admin-principal',
        loadChildren: () =>
          import('./modules/pages/Admin-Principal/admin-principal.module').then(
            m => m.AdminPrincipalModule,
          ),
      },
      {
        path: 'admin-empresa',
        loadChildren: () =>
          import('./modules/pages/Admin-Empresa/admin-empresa.module').then(
            m => m.AdminEmpresaModule,
          ),
      },
      {
        path: 'inspector',
        loadChildren: () =>
          import('./modules/pages/inspector/inspector.module').then(
            m => m.InspectorModule,
          ),
      },
    ],
    canActivate: [LoggedGuard],
  },
  {path: 'denuncia', children:[
    {
      path: '',
      loadChildren: () =>
        import('./modules/pages/denunciante/denunciante.module').then(
          m => m.DenuncianteModule,
        ),
    }
  ]},

  // Not lazy-loaded routes
  {path: 'no-autorizado', component: MaintenanceComponent},
  {path: 'login', component: LoginCComponent},
  {path: '**', redirectTo: 'no-autorizado'},

  // Not found
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { 
      useHash: true,
      preloadingStrategy: PreloadAllModules, 
      relativeLinkResolution: 'legacy' 
    })
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
